import { render, staticRenderFns } from "./proc.vue?vue&type=template&id=2dfe77a0&"
import script from "./proc.vue?vue&type=script&lang=js&"
export * from "./proc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports